import { OutboxStatusEnum } from '../../../platform/outbox/enums/outbox-status.enum';
import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { ApiRequestFilters } from '../../../shared/types/api-request-filters';

/**
 * Reminder log filters
 */
export class ReminderLogFilters extends ApiRequestFilters {
	/**
	 * User IDs
	 */
	users?: number[];

	/**
	 * Outbox message status values
	 */
	statuses?: OutboxStatusEnum[];

	/**
	 * Record category enum values
	 */
	subjects?: AppSubjectEnum[];
}
